import { ColorOptions, MaterialTextInput, mobileNumber } from '@jfs/ui-new'
import { required } from '@jfs/utils'
import { OtpTextInputWithTimer } from '../../../comps/OtpTextInputWithTimer'
import { Colors } from '../../../util/utill'
import { DomesticMoneyTransferStrings } from '../Strings'
import { styles } from './styles'

export const FORM_FIELDS = {
  MOBILE: 'mobileNumber',
  OTP: 'Otp',
  DEBIT_AMOUNT_INFO: 'debitInfo',
}

export const OtpForm = (config?: { mode?: number; purpose?: number; amount?: any }) => [
  {
    verticalSpacing: 10,
    formItems: [
      {
        fieldName: FORM_FIELDS.MOBILE,
        ComponentName: MaterialTextInput,
        label: DomesticMoneyTransferStrings.customerMobile,
        tintColor: Colors.LIGHT_SKY_BLUE,
        placeholderTextColor: Colors.DISABLED_GREY as ColorOptions, //For label color
        color: 'DISABLED_GREY' as ColorOptions,
        validationSchema: mobileNumber,
        bottomLineColor: Colors.LIGHT_SKY_BLUE,
        ...styles.textInputStyle,
        disabled: true,
        maxLength: 10,
      },
      {
        fieldName: FORM_FIELDS.OTP,
        ComponentName: OtpTextInputWithTimer,
        placeholder: DomesticMoneyTransferStrings.enterOtp,
        validationSchema: required,
        ...styles.textInputStyle,
        maxLength: 6,
        options: {
          mode: config?.mode,
          purpose: config?.purpose,
          amount: config?.amount,
        },
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
